import {
  FETCH_BENCHMARK_GENERATION_STATUS_REQUEST,
  FETCH_BENCHMARK_GENERATION_STATUS_SUCCESS,
  FETCH_BENCHMARK_GENERATION_STATUS_FAILURE,
} from "../actions/benchmarkGenerationStatusActions";

const initialState = {
  loading: false,

  // Dummy data until API ready
  //   data: {
  //     client_company: "Stryker",
  //     generation_status: [
  //       {
  //         _id: "1",
  //         client: "Stryker",
  //         competitors: ["Arthrex", "Johnson & Johnson MedTech", "Zimmer Biomet"],
  //         generating: true,
  //         total_prompts: 3,
  //         completed_prompts: 1,
  //         generation_started_at: "2026-05-19T12:03:30.599000",
  //       },
  //       {
  //         _id: "2",
  //         client: "Stryker",
  //         competitors: ["Smith & Nephew", "Medtronic"],
  //         generating: false,
  //         total_prompts: 3,
  //         completed_prompts: 3,
  //         generation_started_at: "2026-05-18T12:03:30.599000",
  //       },
  //     ],
  //   },
  data: {},
  error: null,
};

const benchmarkGenerationStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BENCHMARK_GENERATION_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_BENCHMARK_GENERATION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_BENCHMARK_GENERATION_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default benchmarkGenerationStatusReducer;
